import { createFileRoute, Link, useSearch } from "@tanstack/react-router";
import { z } from "zod";
import { ArrowLeft, Sparkles, Bell } from "lucide-react";

const searchSchema = z.object({
  feature: z.string().min(1).max(80).optional(),
  back: z.string().min(1).max(120).optional(),
});

export const Route = createFileRoute("/coming-soon")({
  validateSearch: searchSchema,
  head: () => ({
    meta: [
      { title: "Coming Soon — Recovery Trauma™" },
      {
        name: "description",
        content:
          "This feature is gently in development. We're building Recovery Trauma™ at the pace of healing — thoughtfully, never rushed.",
      },
      { name: "robots", content: "noindex" },
      { property: "og:title", content: "Coming Soon — Recovery Trauma™" },
      { property: "og:description", content: "This feature is gently in development. We're building Recovery Trauma™ at the pace of healing — thoughtfully, never rushed." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
      { property: "og:url", content: "https://recoverytrauma.com/coming-soon" },
    ],
    links: [{ rel: "canonical", href: "https://recoverytrauma.com/coming-soon" }],
  }),
  component: ComingSoonPage,
});

function ComingSoonPage() {
  const { feature, back } = useSearch({ from: "/coming-soon" });

  return (
    <div className="mx-auto max-w-2xl px-4 py-16 text-center">
      <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-[var(--gradient-gold)] text-3xl shadow-[var(--shadow-gold)]">
        🌿
      </div>
      <span className="inline-flex min-h-10 sm:min-h-0 items-center gap-1.5 rounded-full border border-gold/40 bg-cream/60 px-3 py-1 text-xs font-medium text-[var(--gold-deep)]">
        <Sparkles className="h-3 w-3" />
        In gentle development
      </span>
      <h1 className="mt-4 font-serif text-4xl text-foreground">
        {feature ? `${feature} is coming soon` : "Coming soon"}
      </h1>
      <p className="mx-auto mt-3 max-w-md text-muted-foreground">
        We're building this carefully and trauma-informedly. It will arrive when
        it's truly ready to support you — never rushed.
      </p>

      <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
        <Link
          to={back || "/"}
          className="inline-flex min-h-10 sm:min-h-0 items-center gap-1.5 rounded-full border border-gold/40 bg-cream/60 px-4 py-2 text-sm font-medium text-foreground"
        >
          <ArrowLeft className="h-3.5 w-3.5" />
          Go back
        </Link>
        <Link
          to="/roadmap"
          className="inline-flex items-center gap-1.5 rounded-full bg-[var(--gradient-gold)] px-4 py-2 text-sm font-medium text-foreground shadow-[var(--shadow-gold)]"
        >
          <Bell className="h-3.5 w-3.5" />
          See the roadmap
        </Link>
      </div>
    </div>
  );
}
